import { CURRENT_COUNTRY_ID } from '~constants/environment';
import { PAYMENT_METHODS_INFO, PAYMENT_METHODS } from '~constants/paymentMethods';
import { isSafariBrowser } from '~utils/userAgent';

export const getPaymentMethod = paymentKey =>
  paymentKey === PAYMENT_METHODS.applepay && !isSafariBrowser()
    ? null
    : PAYMENT_METHODS_INFO[CURRENT_COUNTRY_ID][paymentKey];
